import { render, staticRenderFns } from "./ImgNews.vue?vue&type=template&id=2412b1c8"
import script from "./ImgNews.vue?vue&type=script&lang=js"
export * from "./ImgNews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports